import { Button, Dialog,DialogContent,DialogActions,AppBar,Typography, createStyles, Theme, withStyles,WithStyles,Toolbar} from '@material-ui/core';
import { DeltaXMLColors } from './styling/DeltaColors';

const styles = (theme: Theme) =>
  createStyles({
    appBar: {
      alignItems: "left",
      backgroundColor: DeltaXMLColors.OXFORD_BLUE,
    },
    button: {
      margin: '20px'
    }
  });

export interface ErrorDialogSaasProps extends WithStyles<typeof styles> {
    errorMessage:JSX.Element
    dialogOpen:boolean
    handleCloseDialog: () => void;
  }
  
 function ErrorDialogSaaS(props: ErrorDialogSaasProps) {
    const {classes, errorMessage, dialogOpen, handleCloseDialog} = props;
  return (
    <>
    <Dialog open={dialogOpen}>
      <AppBar className={classes.appBar} position="static">
        <Toolbar>
          <Typography variant="h4">Error</Typography>
        </Toolbar>
      </AppBar>
      <br />
      <DialogContent>
        {errorMessage}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} variant="contained" color="primary" >
          OK
        </Button>
      </DialogActions>
    </Dialog>
   </>
  );
}

export default withStyles(styles)(ErrorDialogSaaS);
